import type { Driver, DriverTask } from '@/types';

/**
 * Demo sub-drivers belonging to the signed-in laundry only.
 * Documents use safe illustrative placeholders (never real documents).
 * Replaced by the laundry drivers API later — nothing is persisted.
 */
export const mockDrivers: Driver[] = [
  {
    id: 'DRV-3001',
    fullName: 'سلطان الغامدي',
    phone: '0551112233',
    username: 'sultan.g',
    avatarUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Saudi%20Arabian%20man%20in%20his%20thirties%20wearing%20a%20clean%20collared%20shirt%2C%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20friendly%20confident%20expression%2C%20sharp%20focus%20on%20the%20face%2C%20editorial%20corporate%20photography%20style&width=400&height=400&seq=driver-avatar-1&orientation=squarish',
    availability: 'available',
    accountDisabled: false,
    documents: {
      nationalId: {
        fileName: 'national-id.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20official%20identification%20card%20lying%20flat%20on%20a%20clean%20bright%20white%20surface%2C%20softly%20blurred%20and%20unreadable%20printed%20details%2C%20neutral%20studio%20lighting%2C%20no%20personal%20information%20visible%2C%20minimal%20top%20down%20editorial%20product%20photograph&width=600&height=600&seq=driver-doc-id&orientation=squarish',
      },
      license: {
        fileName: 'driving-license.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20driving%20license%20card%20placed%20on%20a%20clean%20light%20surface%2C%20all%20printed%20text%20blurred%20and%20unreadable%2C%20soft%20neutral%20studio%20lighting%2C%20no%20personal%20data%20visible%2C%20minimal%20top%20down%20flat%20lay%20photograph&width=600&height=600&seq=driver-doc-license&orientation=squarish',
      },
      vehicle: {
        fileName: 'vehicle.jpg',
        url: 'https://readdy.ai/api/search-image?query=Plain%20white%20delivery%20van%20parked%20against%20a%20neutral%20light%20gray%20studio%20background%2C%20clean%20side%20view%2C%20no%20logos%20or%20text%2C%20soft%20even%20lighting%2C%20minimal%20commercial%20vehicle%20photography&width=800&height=600&seq=driver-doc-vehicle&orientation=landscape',
      },
    },
  },
  {
    id: 'DRV-3002',
    fullName: 'فهد الزهراني',
    phone: '0552223344',
    username: 'fahad.z',
    avatarUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Saudi%20Arabian%20man%20in%20his%20forties%20with%20a%20short%20trimmed%20beard%20wearing%20a%20clean%20collared%20shirt%2C%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20calm%20confident%20expression%2C%20editorial%20corporate%20photography%20style&width=400&height=400&seq=driver-avatar-2&orientation=squarish',
    availability: 'busy',
    accountDisabled: false,
    documents: {
      nationalId: {
        fileName: 'national-id.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20official%20identification%20card%20lying%20flat%20on%20a%20clean%20bright%20white%20surface%2C%20softly%20blurred%20and%20unreadable%20printed%20details%2C%20neutral%20studio%20lighting%2C%20no%20personal%20information%20visible%2C%20minimal%20top%20down%20editorial%20product%20photograph&width=600&height=600&seq=driver-doc-id&orientation=squarish',
      },
      license: {
        fileName: 'driving-license.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20driving%20license%20card%20placed%20on%20a%20clean%20light%20surface%2C%20all%20printed%20text%20blurred%20and%20unreadable%2C%20soft%20neutral%20studio%20lighting%2C%20no%20personal%20data%20visible%2C%20minimal%20top%20down%20flat%20lay%20photograph&width=600&height=600&seq=driver-doc-license&orientation=squarish',
      },
      vehicle: null,
    },
  },
  {
    id: 'DRV-3003',
    fullName: 'ماجد العنزي',
    phone: '0553334455',
    username: 'majed.a',
    avatarUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Saudi%20Arabian%20man%20wearing%20a%20clean%20collared%20shirt%2C%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20friendly%20expression%2C%20sharp%20focus%2C%20editorial%20corporate%20photography%20style&width=400&height=400&seq=driver-avatar-3&orientation=squarish',
    availability: 'available',
    accountDisabled: false,
    documents: {
      nationalId: {
        fileName: 'national-id.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20official%20identification%20card%20lying%20flat%20on%20a%20clean%20bright%20white%20surface%2C%20softly%20blurred%20and%20unreadable%20printed%20details%2C%20neutral%20studio%20lighting%2C%20no%20personal%20information%20visible%2C%20minimal%20top%20down%20editorial%20product%20photograph&width=600&height=600&seq=driver-doc-id&orientation=squarish',
      },
      license: null,
      vehicle: {
        fileName: 'vehicle.jpg',
        url: 'https://readdy.ai/api/search-image?query=Plain%20white%20delivery%20van%20parked%20against%20a%20neutral%20light%20gray%20studio%20background%2C%20clean%20side%20view%2C%20no%20logos%20or%20text%2C%20soft%20even%20lighting%2C%20minimal%20commercial%20vehicle%20photography&width=800&height=600&seq=driver-doc-vehicle&orientation=landscape',
      },
    },
  },
  {
    id: 'DRV-3004',
    fullName: 'راشد القرني',
    phone: '0554445566',
    username: 'rashed.q',
    avatarUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Saudi%20Arabian%20man%20in%20his%20thirties%20with%20glasses%20wearing%20a%20clean%20collared%20shirt%2C%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20calm%20expression%2C%20editorial%20corporate%20photography%20style&width=400&height=400&seq=driver-avatar-4&orientation=squarish',
    availability: 'unavailable',
    accountDisabled: false,
    documents: {
      nationalId: {
        fileName: 'national-id.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20official%20identification%20card%20lying%20flat%20on%20a%20clean%20bright%20white%20surface%2C%20softly%20blurred%20and%20unreadable%20printed%20details%2C%20neutral%20studio%20lighting%2C%20no%20personal%20information%20visible%2C%20minimal%20top%20down%20editorial%20product%20photograph&width=600&height=600&seq=driver-doc-id&orientation=squarish',
      },
      license: null,
      vehicle: null,
    },
  },
  {
    id: 'DRV-3005',
    fullName: 'عبدالله الدوسري',
    phone: '0555556677',
    username: 'abdullah.d',
    avatarUrl:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Saudi%20Arabian%20man%20in%20his%20forties%20with%20a%20neat%20trimmed%20beard%20wearing%20a%20clean%20collared%20shirt%2C%20plain%20light%20gray%20studio%20background%2C%20soft%20even%20lighting%2C%20editorial%20corporate%20photography%20style&width=400&height=400&seq=driver-avatar-5&orientation=squarish',
    availability: 'unavailable',
    accountDisabled: true,
    documents: {
      nationalId: {
        fileName: 'national-id.jpg',
        url: 'https://readdy.ai/api/search-image?query=Generic%20official%20identification%20card%20lying%20flat%20on%20a%20clean%20bright%20white%20surface%2C%20softly%20blurred%20and%20unreadable%20printed%20details%2C%20neutral%20studio%20lighting%2C%20no%20personal%20information%20visible%2C%20minimal%20top%20down%20editorial%20product%20photograph&width=600&height=600&seq=driver-doc-id&orientation=squarish',
      },
      license: null,
      vehicle: null,
    },
  },
];

/** Read-only completed task history. Each order may have a pickup + delivery. */
export const mockDriverTasks: DriverTask[] = [
  {
    id: 'TSK-9001',
    driverId: 'DRV-3001',
    type: 'pickup',
    orderId: 'LB-1031',
    completedAt: '2026-10-11T09:15:00',
    deliveryFee: 15,
  },
  {
    id: 'TSK-9002',
    driverId: 'DRV-3001',
    type: 'delivery',
    orderId: 'LB-1031',
    completedAt: '2026-10-11T16:40:00',
    deliveryFee: 18,
  },
  {
    id: 'TSK-9003',
    driverId: 'DRV-3002',
    type: 'pickup',
    orderId: 'LB-1030',
    completedAt: '2026-10-10T11:05:00',
    deliveryFee: 15,
  },
  {
    id: 'TSK-9004',
    driverId: 'DRV-3002',
    type: 'delivery',
    orderId: 'LB-1030',
    completedAt: '2026-10-10T18:20:00',
    deliveryFee: 20,
  },
  {
    id: 'TSK-9005',
    driverId: 'DRV-3003',
    type: 'delivery',
    orderId: 'LB-1029',
    completedAt: '2026-10-10T14:35:00',
    deliveryFee: 17.5,
  },
  {
    id: 'TSK-9006',
    driverId: 'DRV-3003',
    type: 'pickup',
    orderId: 'LB-1029',
    completedAt: '2026-10-10T09:50:00',
    deliveryFee: 15,
  },
];